import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Grid,
  Input,
  InputAdornment,
  Typography,
} from "@mui/material";
import { debounce } from "radash";
import { useEffect, useMemo, useState } from "react";
import { Form, useNavigation, useSubmit } from "react-router-dom";

const SEARCH_DELAY = 200;

const PublishersListHeader = ({ filters }) => {
  const submit = useSubmit();
  const submitDebounced = useMemo(
    () => debounce({ delay: SEARCH_DELAY }, submit),
    [submit]
  );
  const navigation = useNavigation();
  const [searchTerm, setSearchTerm] = useState(filters.search ?? "");

  useEffect(() => {
    if (navigation.state === "loading") {
      const searchParams = new URLSearchParams(navigation.location.search);
      setSearchTerm(searchParams.get("search") ?? "");
    }
  }, [navigation.state, navigation.location]);

  return (
    <Form
      data-testid={"programmatic-supply-publishers-searchform"}
      method="get"
      onChange={(e) => {
        const isFirstSearch = filters.search === undefined;

        e.target.name === "search"
          ? submitDebounced({ ...filters, page: 1, search: e.target.value }, { method: "get", replace: !isFirstSearch })
          : submit({ ...filters, page: 1, search: e.target.value }, { method: "get", replace: !isFirstSearch });
      }}
    >
      <Grid container sx={{ py: 4 }}>
        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box>
            <Typography variant="h6">Publishers</Typography>
          </Box>
          <Box sx={{ alignSelf: "center" }}>
            <Input
              name="search"
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
              type="search"
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
            />
          </Box>
        </Grid>
      </Grid>
    </Form>
  );
};

export default PublishersListHeader;
